<template>
  <div id="status">
    <Banner title="會員專區" :breadcrumbs="breadcrumbs" type="member"></Banner>
    <div class="container">
      <div class="center_title">
        <Title
          en="Annual Fee"
          chtFirst="年會費"
          chtSecond="繳納"
          :center="true"
        ></Title>
      </div>
      <!-- <div class="test">
        測試狀態用
        <select v-model="memberStatus">
          <option value="10">信箱未驗證</option>
          <option value="20">未填寫會員資料</option>
          <option value="30">未上傳資料</option>
          <option value="40">審核中</option>
          <option value="50">審核未過</option>
          <option value="60">未繳費</option>
          <option value="70">已繳費</option>
        </select>
      </div>-->
      <section class="content">
        <div class="global_title">
          會員狀態
          <span>{{ showtext.Status }}</span>
        </div>
        <div class="message">
          <div>
            <strong>E-mail帳號:</strong>
            {{ email }}
          </div>
          <div class="remark" v-html="showtext.Remark"></div>
        </div>
        <form class="update" v-if="memberStatus == 30 || memberStatus == 50">
          <div class="file_item" v-if="isFailfile.app">
            <span>完成簽名的入會申請書</span>
            <label v-show="!files[0]">
              <span>上傳檔案</span>
              <input
                type="file"
                @change="onFileChange($event, 0, 'app')"
                ref="file0"
              />
              <span>，檔案請小於2.0MB</span>
            </label>
            <div class="file_name" v-if="files[0]">
              <div>
                <pdficon />
                {{ files[0] }}
              </div>
              <div @click="deleteFile(0)">
                <span>✖</span>
                <span>刪除</span>
              </div>
            </div>
          </div>
          <div class="file_item" v-if="isFailfile.dip">
            <span>醫學院校畢業證書影本</span>
            <label v-show="!files[1]">
              <span>上傳檔案</span>
              <input
                type="file"
                @change="onFileChange($event, 1, 'dip')"
                ref="file1"
              />
              <span>，檔案請小於2.0MB</span>
            </label>
            <div class="file_name" v-if="files[1]">
              <div>
                <pdficon />
                {{ files[1] }}
              </div>
              <div @click="deleteFile(1)">
                <span>✖</span>
                <span>刪除</span>
              </div>
            </div>
          </div>
          <div class="file_item" v-if="isFailfile.cer">
            <span>醫師證書影本</span>
            <label v-show="!files[2]">
              <span>上傳檔案</span>
              <input
                type="file"
                @change="onFileChange($event, 2, 'cer')"
                ref="file2"
              />
              <span>，檔案請小於2.0MB</span>
            </label>
            <div class="file_name" v-if="files[2]">
              <div>
                <pdficon />
                {{ files[2] }}
              </div>
              <div @click="deleteFile(2)">
                <span>✖</span>
                <span>刪除</span>
              </div>
            </div>
          </div>
          <div class="file_item" v-if="isFailfile.spe">
            <span>專科醫師證書影本</span>
            <label v-show="!files[3]">
              <span>上傳檔案</span>
              <input
                type="file"
                @change="onFileChange($event, 3, 'spe')"
                ref="file3"
              />
              <span>，檔案請小於2.0MB</span>
            </label>
            <div class="file_name" v-if="files[3]">
              <div>
                <pdficon />
                {{ files[3] }}
              </div>
              <div @click="deleteFile(3)">
                <span>✖</span>
                <span>刪除</span>
              </div>
            </div>
          </div>
        </form>

        <div class="btn_box" v-if="memberStatus == 10">
          <div class="Orange_btn islogin" @click="sendEmail">
            <a href="javascript:;">寄送驗證信</a>
          </div>
        </div>

        <div class="btn_box" v-if="memberStatus == 20">
          <div class="Orange_btn islogin">
            <a href="/Member">填寫資料</a>
          </div>
        </div>

        <div
          class="btn_box two"
          v-if="memberStatus == 30 || memberStatus == 50"
        >
          <div class="White_btn islogin" @click="resetFile">
            <a href="javascript:;">修改資料</a>
          </div>
          <div class="Orange_btn islogin" @click="sendfile">
            <a href="javascript:;">確認送出</a>
          </div>
        </div>

        <div class="btn_box" v-if="memberStatus == 40">
          <div class="Orange_btn islogin">
            <a href="/Home/ContactUs">聯絡我們</a>
          </div>
        </div>

        <div class="btn_box" v-if="memberStatus == 60">
          <div class="Orange_btn islogin" @click="joinMember">
            <a href="javascript:;">前往繳費</a>
          </div>
        </div>
        <!-- <div class="global_title" v-if="memberStatus == 70">
          會期狀態<span class="print_link" @click="goPrint">列印最新收據</span>
        </div> -->
        <div class="list" v-if="memberStatus == 70">
          <div class="item">
            <div class="date">
              <span>第1期</span>
              <span>{{ $moment(StartDate).format("YYYY") }}年</span>
            </div>
            <div class="money">
              <div>
                <span>入會費</span>
                <span>5000元</span>
              </div>
              <div>
                <span>當年會費</span>
                <span
                  >{{
                    $moment(StartDate).format("YYYY") > 2013 ? "1000" : "2000"
                  }}元</span
                >
              </div>
            </div>
            <div class="item_status">
              <span>已繳費</span>
              <div v-if="Membership.length == 0">
                <span class="print_link" @click="goPrint">列印收據</span>
              </div>
            </div>
          </div>
          <div
            class="item"
            v-for="(memberShip, index) in Membership"
            :key="index"
          >
            <div class="date">
              <span>第{{ memberShip.Id }}期</span>
              <span>{{ memberShip.Year }}年</span>
            </div>
            <div class="money">
              <div>
                <span>{{
                  memberShip.IsExpired ? "當年會費(已過期)" : "當年會費"
                }}</span>
                <span>{{ memberShip.Year > 2013 ? "1000" : "2000" }}元</span>
              </div>
            </div>
            <div class="item_status">
              <span :class="{ red: !memberShip.Status }">{{
                memberShip.Status ? "已繳費" : "未繳費"
              }}</span>
              <div v-if="index == Membership.map(el => el.Status).lastIndexOf(true)">
                <span class="print_link" @click="goPrint">列印收據</span>
              </div>
            </div>
            <!-- <div class="item_detail">+</div> -->
          </div>
        </div>
        <div class="renewal" v-if="IsRenew">
          <div class="money">
            <span>未繳期數:共{{ TotalPay.Total }}期</span>
            <span>總計:{{ TotalPay.Money }}</span>
          </div>
          <div class="btn_box">
            <div class="Orange_btn islogin" @click="renewalMember">
              <a href="javascript:;">前往繳費</a>
            </div>
          </div>
        </div>
      </section>
      <graybtn />
    </div>
    <transition>
      <Popup v-if="popupshow" @closePopup="closePopup">
        <p>恭喜您!已完成申請入會上傳</p>
        <p>
          入會資格審核需
          <span>3-5個工作天</span>，完成審核後將寄送信件通知，
          <br />如果經過一段時間，您仍然沒有收到
          <span>中華民國視網膜學會</span>的帳號驗證信件，
          <br />郵件有可能被分類到垃圾信件。請查看您的垃圾郵件信件箱
        </p>
        <p>
          同時，您也可以登入
          <span>中華民國視網膜學會</span>會員專區，確認您的會員狀態,
          <br />若已顯示為 <span>"已完成會員認證"</span>，煩請您點選 "前往付費"
          ，待完成付費後即可啟用 "正式會員"之功能。 <br />若顯示仍為
          "帳號註冊完成"，您可以在此頁確認是否有缺少資料或其他問題，
          <br />煩請您依照頁面指示再次完成認證流程，或
          <span>與我們聯繫</span>，以利完成您的會員資格認證。
        </p>
        <div class="btn_box">
          <div class="Orange_btn islogin" @click="reload">
            <a href="javascript:;">確認</a>
          </div>
        </div>
      </Popup>
    </transition>
    <loading v-if="isLoading"></loading>
  </div>
</template>

<script>
import Popup from "@/components/popup";
import API from "@/service/member";
export default {
  name: "status",
  components: {
    Popup,
  },
  props: {
    email: {
      type: String,
    },
    valemail: {
      type: Boolean,
    },
    isupdated: {
      type: Boolean,
    },
    auditstatus: {
      type: String,
    },
    memberinfo: {
      type: Object,
    },
  },
  data() {
    return {
      breadcrumbs: [
        {
          url: "/",
          title: "首頁",
        },
        {
          title: "會員專區",
        },
        {
          url: "/Member/Status",
          title: "年會費繳納",
        },
      ],
      memberStatus: Number,
      showtext: {},
      files: ["", "", "", ""],
      popupshow: false,
      btnStatus: true,
      api: {},
      isFailfile: {
        app: true,
        dip: true,
        cer: true,
        spe: true,
      },
      StartDate: "",
      EndDate: "",
      NowDate: this.$moment().valueOf(),
      TotalPay: {},
      IsRenew: false,
      isLoading: false,
    };
  },
  methods: {
    onFileChange(e, index, type) {
      const vm = this;
      let files = e.target.files || e.dataTransfer.files;
      // console.log(files);
      if (files[0].size >= 2000000) {
        vm.$swal({
          type: "warning",
          text: "檔案大小超過 2MB，請重新選擇檔案",
          confirmButtonText: "確定",
        });
        return false;
      }
      if (!files.length) return;
      vm.$set(vm.files, index, files[0].name);
      let updatefile = new FormData();
      updatefile.append(type, files[0]);

      //console 用
      // for (let key of updatefile.entries()) {
      //   console.log(key[0] + ", " + key[1]);
      // }
      API.getUpdateFile(type, updatefile).then((res) => {
        // console.log(res);
        if (!res.Ok) {
          vm.$swal({
            type: "warning",
            text: "檔案類型不正確，請上傳PDF檔案。",
            confirmButtonText: "確定",
          });
          vm.$set(vm.files, index, "");
        }
      });
    },
    deleteFile(index) {
      const vm = this;
      const files = vm.$refs["file" + index];
      files.value = "";
      vm.$set(vm.files, index, "");
    },
    resetFile() {
      const vm = this;
      for (let i = 0; i < 4; i++) {
        vm.$refs["file" + i].value = "";
        vm.$set(vm.files, i, "");
      }
    },
    sendfile() {
      const vm = this;
      API.getCheckFile().then((res) => {
        if (res.Ok) {
          vm.popupshow = true;
        }
      });
    },
    closePopup() {
      const vm = this;
      vm.popupshow = false;
    },
    reload() {
      location.reload();
    },
    sendEmail() {
      const vm = this;
      if (!vm.btnStatus) {
        return false;
      }
      vm.btnStatus = false;
      vm.isLoading = true;
      API.getSendEmail((res) => {
        console.log(res);
        vm.isLoading = false;

        if (res.Ok) {
          vm.$swal({
            type: "success",
            text: "寄信成功，請至您的信箱收取信件。",
            confirmButtonText: "確定",
          });
        } else {
          vm.$swal({
            type: "fail",
            text: "寄信失敗，請稍後在試。",
            confirmButtonText: "確定",
          });
        }
        setTimeout(function () {
          vm.btnStatus = true;
        }, 2000);
      });
      setTimeout(function () {
        vm.isLoading = false;
      }, 3000);
    },
    selectMemberStatus(Status) {
      const vm = this;
      switch (Status) {
        case 10:
          vm.showtext = {
            Status: `帳號驗證中(等候驗證)`,
            Remark: `若您未收到驗證信，同時垃圾信箱內也未收到，請點擊 "寄送驗證信。"`,
          };
          break;
        case 20:
          vm.showtext = {
            Status: `帳號註冊完成(未填寫資料)`,
            Remark: `已完成註冊，請前往填寫資料。`,
          };
          break;
        case 30:
          vm.showtext = {
            Status: `帳號註冊完成(請上傳申請入會資料)`,
            Remark: `已完成帳號註冊，請以下方指示上傳資料，若有資料須修改請點擊。`,
          };
          break;
        case 40:
          vm.showtext = {
            Status: `帳號註冊完成(申請入會審核中)`,
            Remark: `請等候3-5個工作天，若有問題請聯絡我們。`,
          };
          break;
        case 50:
          vm.showtext = {
            Status: `帳號註冊完成(申請入會-待補資料)`,
            Remark: `您所提供的資料有問題，請依下列須提供資料再次上傳，謝謝!`,
          };
          break;
        case 60:
          vm.showtext = {
            Status: `已完成會員認證(審核完成-未繳費)`,
            Remark: `已完成審核，請前往完成付費。<p>入會費5000元，當年會費1000元，共計6000元。</p>`,
          };
          break;
        case 70:
          if (vm.$moment(vm.EndDate).valueOf() >= vm.$moment().valueOf()) {
            vm.showtext = {
              Status: `正式會員`,
              Remark: `已完成認證會員，有效日期:<span>${vm
                .$moment(vm.EndDate)
                .format("YYYY-MM-DD")}</span>到期。`,
            };
          } else {
            vm.showtext = {
              Status: `正式會員(已過期)`,
              Remark: `已完成認證會員，有效日期:<span>${vm
                .$moment(vm.EndDate)
                .format(
                  "YYYY-MM-DD"
                )}</span>已到期，請確認下方會期時間與未繳費金額並前往繳費，請開通認證會員權限，謝謝。`,
            };
          }
          break;
      }
    },
    joinMember() {
      const vm = this;
      // 10/18 暫時隱藏繳費功能
      API.getJoinTrs().then((res) => {
        if (res.Ok) {
          location.href = res.Data;
        }
      });
      // 10/18 暫時以彈出視窗取代繳費功能
      // vm.$swal({
      //       type: "warning",
      //       text: "年會期間暫時關閉線上繳費功能，請於年會上繳納，或於年會結束後再使用線上繳費功能。",
      //       confirmButtonText: "確定"
      //     });
    },
    renewalMember() {
      const vm = this;
      // 10/18 暫時隱藏繳費功能
      API.getRenewalTrs().then((res) => {
        if (res.Ok) {
          location.href = res.Data;
        }
      });

      // 10/18 暫時以彈出視窗取代繳費功能
      // vm.$swal({
      //       type: "warning",
      //       text: "年會期間暫時關閉線上繳費功能，請於年會上繳納，或於年會結束後再使用線上繳費功能。",
      //       confirmButtonText: "確定"
      //     });
    },
    goPrint() {
      const vm = this;
      vm.$swal({
        text: "請輸入抬頭，如未輸入則預設為會員名稱",
        input: 'text',
        confirmButtonText: "確定",
        confirmButtonColor: '#ee8b59'
      }).then((result) => {
        API.getPrintMember().then((res) => {
        if (res.Ok && !res.Message) {
          const data = res.Data;
          let tmpItems = "";
          let tmpResult = "";
          for (let i = 0; i < data.items.length; i++) {
            if (data.IsTOIS) {
              tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;padding: 5px;">${data.items[i].Title}<br>眼部炎症會員</td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;padding: 5px;">${data.items[i].Amount}</td>
      </tr>`;
            } else {
              tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;padding: 5px;">${data.items[i].Title}</td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;padding: 5px;">${data.items[i].Amount}</td>
      </tr>`;
            }
          }
          tmpResult = `<div>
          <img src="https://www.retina.org.tw/images/trslogo.png" alt="TRS" style="position: absolute;top: 0;left: 0;margin-top: 18px;width: 180px;">
  <img src="https://www.retina.org.tw/images/%E8%A6%96%E7%B6%B2%E8%86%9C%E9%86%AB%E5%AD%B8%E6%9C%83_%E6%94%B6%E6%93%9A%E5%B0%88%E7%94%A8%E7%AB%A0-01.png" alt="TRS" style="position: absolute;top: 0;left: 50%;transform: translateX(-50%);width: 110px;">
  <h1 style="text-align: center;font-size: 20pt;font-weight: bold;margin-bottom: 5px;letter-spacing: 10px;">中華民國視網膜醫學會</h1>
  <p style="text-align: center;font-size: 12pt;margin-bottom: 5px;margin-top: 0;">10048台北市常德街1號景福館2樓206室/電話:0965-106869</p>
  <h2 style="text-align: center;font-size: 16pt;font-weight: bold;margin-bottom: 5px;margin-top: 5px;">《收據》</h2>
  <p style="font-size: 9pt;">統一編號 : 31828080</p>
  <p style="font-size: 9pt;">立案字號 : 台內社字第1010115120號</p>
  <p style="font-size: 12pt;">繳費日期 :${data.OrderPayOn}</p>
  <table style="width: 100%;border-spacing: 0px;">
    <thead>
      <tr>
        <th style="text-align: left;font-size: 12pt;width: 60%;padding: 5px;">茲收到：${
          result.value?result.value:data.Name
        }</th>
        <th style="text-align: left;font-size: 12pt;width: 40%;padding: 5px;">會員編號：${
          data.MemberNumber ? data.MemberNumber : ""
        }</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="text-align: center;background-color: #E1E2E4;font-size: 12pt;border: 1px solid #000;padding: 5px;">項目</td>
        <td style="text-align: center;background-color: #E1E2E4;font-size: 12pt;border: 1px solid #000;padding: 5px;">金額</td>
      </tr>
      ${tmpItems}
      <tr>
        <td></td>
        <td style="font-size: 12pt;padding: 5px;font-weight: bold;">總計： ${
          data.TotalAmount
        }整</td>
      </tr>
    </tbody>
    </table>
    <p style="text-align: center;font-size: 10pt;padding: 20px 0 10px 0;">※此收據請妥善保管，遺失恕不補發</p></div>`;
          let printWindow = window.open("", "", "height=400,width=800");
          printWindow.document.write(tmpResult);
          printWindow.document.close();
          setTimeout(() => {
            printWindow.print();
          }, 1000);
        } else {
          vm.$swal({
            type: "warning",
            text: "請稍後再試。",
            confirmButtonText: "確定",
          });
        }
      });
      })
    },
  },
  computed: {
    Membership() {
      //計算會期表單 包刮總金額
      const vm = this;
      const paid_year = vm
        .$moment(vm.EndDate)
        .diff(vm.$moment(vm.StartDate), "years");
      let _date = [];
      let _year_paid = 0;
      for (let i = 1; i <= paid_year; i++) {
        _year_paid = parseInt(vm.$moment(vm.StartDate).format("YYYY")) + i;
        _date.push({
          Id: i + 1,
          Year: _year_paid,
          Status: true,
          IsExpired: false,
          Money: _year_paid > 2013 ? 1000 : 2000,
        });
      }
      // console.log("現在年分", vm.$moment().format("YYYY"));

      // console.log("到期年分", vm.$moment(vm.EndDate).format("YYYY"));
      let unpaid_year;
      if (vm.$moment().format("YYYY") > vm.$moment(vm.EndDate).format("YYYY")) {
        unpaid_year =
          vm.$moment().format("YYYY") - vm.$moment(vm.EndDate).format("YYYY");
        vm.IsRenew = true;
      } else {
        unpaid_year = 0;
      }
      let _year = 0;
      // console.log(unpaid_year);
      for (let i = 1; i <= unpaid_year; i++) {
        _year =
          parseInt(vm.$moment(vm.StartDate).format("YYYY")) + paid_year + i;
        if (i == unpaid_year) {
          _date.push({
            Id: paid_year + i + 1,
            Year: _year,
            Status: false,
            IsExpired: false,
            Money: _year > 2013 ? 1000 : 2000,
          });
        } else {
          _date.push({
            Id: paid_year + i + 1,
            Year: _year,
            Status: false,
            IsExpired: true,
            Money: _year > 2013 ? 1000 : 2000,
          });
        }
      }
      //拉出沒有繳費的
      let mustpay = _date.filter((item) => {
        return item.Status == false;
      });
      let _TotalPay = 0;
      //計算總共要繳多少
      mustpay.forEach((item) => {
        _TotalPay += item.Money;
      });

      vm.TotalPay = {
        Total: mustpay.length,
        Money: _TotalPay,
      };

      // console.log(vm.$moment(vm.EndDate));

      // console.log(vm.TotalPay);
      // console.log(year);
      // console.log(_date);
      return _date;
    },
  },
  created() {
    const vm = this;

    // status lsit
    // 10 尚未信箱驗證
    // 20 尚未填寫會員資料
    // 30 尚未上傳申請入會資料
    // 40 審核中
    // 50 審核未過
    // 60 審核通過未付費
    // 70 已付費

    //test
    // vm.StartDate = "2015-07-29T00:00:00";
    // vm.EndDate = "2017-12-31T23:59:59";
    //test
    if (vm.memberinfo) {
      vm.api = JSON.parse(vm.memberinfo);
      if (parseInt(vm.$moment(vm.api.StartOn).format("YYYY")) < 1000) {
        vm.StartDate = vm
          .$moment(vm.api.StartOn)
          .add(1911, "years")
          .format("YYYY");
      } else {
        vm.StartDate = vm.api.StartOn;
      }
      vm.EndDate = vm.api.EndOn;
      // console.log(vm.StartDate);
      // console.log(vm.EndDate);
    }

    // console.log(vm.EndDate);

    if (!vm.valemail) {
      vm.memberStatus = 10;
    } else if (!vm.isupdated) {
      vm.memberStatus = 20;
    } else if (vm.auditstatus == "None") {
      vm.memberStatus = 30;
    } else if (vm.auditstatus == "Processing") {
      vm.memberStatus = 40;
    } else if (vm.auditstatus == "Success" && vm.api.StartOn == null) {
      vm.memberStatus = 60;
    } else if (vm.auditstatus == "Fail") {
      vm.memberStatus = 50;
      // console.log("IsUploadApplicationForm", vm.api.IsUploadApplicationForm);
      if (vm.api.IsUploadApplicationForm) {
        vm.$set(vm.isFailfile, "app", false);
      }
      if (vm.api.IsUploadCertificationPhotocopy) {
        vm.$set(vm.isFailfile, "dip", false);
      }
      if (vm.api.IsUploadDiplomaPhotocopy) {
        vm.$set(vm.isFailfile, "cer", false);
      }
      if (vm.api.IsUploadSpecialistPhotocopy) {
        vm.$set(vm.isFailfile, "spe", false);
      }
      // console.log(vm.isFailfile);
    } else {
      vm.memberStatus = 70;
    }
    // vm.memberStatus = 70;
    vm.selectMemberStatus(vm.memberStatus);
    // console.log(vm.Membership);
    // console.log("Email", vm.email);//獲取會員的帳號
    // console.log("EmailValidate", vm.valemail);//是否驗證過信箱
    // console.log("IsUpdated", vm.isupdated);//更新過會員資料?
    // console.log("auditstatus", vm.auditstatus);//文件驗證狀態

    // console.log(vm.NowDate);//現在時間
  },
  mounted() {},
  watch: {
    memberStatus: {
      immediate: true,
      handler(value) {
        const vm = this;
        vm.selectMemberStatus(parseInt(value));
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#status .content {
  border: 8px solid #eee;
  padding: 20px;
  color: #666;
}
#status .message {
  padding: 0 16px;
  /* min-height: 200px; */
  letter-spacing: 2px;
  line-height: 1.5;
}
#status .list {
  padding: 0 16px;
  letter-spacing: 2px;
  line-height: 1.5;
}
#status .message > div {
  margin-bottom: 30px;
}
#status .message > div > strong {
  font-weight: 600;
}
#status .message .remark >>> p {
  font-size: 0.8rem;
}
#status .message .remark >>> span {
  color: #f00;
}
#status .btn_box {
  width: 165px;
  /* padding: 30px 16px; */
  margin: 40px auto 20px;
}
#status .btn_box.two {
  width: 50%;
  display: flex;
  align-items: center;
}
#status .btn_box.two > div:nth-child(1) {
  margin-right: 10px;
}
#status .update {
  padding: 0 16px;
}
#status .update .file_item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  height: 58px;
}
#status .update .file_item > span {
  width: 170px;
  margin-right: 10px;
}
#status .update .file_item > label {
  display: flex;
  align-items: center;
}
#status .update .file_item > label > span:nth-child(1) {
  background-color: #a59b92;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  padding: 5px 20px;
}
#status .update .file_item input {
  display: none;
}
#status .update .file_item .file_name {
  display: flex;
  align-items: center;
}
#status .update .file_item .file_name > div:nth-child(1) {
  border: 1px solid #eee;
  padding: 10px 12px;
  min-width: 250px;
  display: flex;
  align-items: center;
}
#status .update .file_item .file_name > div:nth-child(2) {
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
}
#status .update .file_item .file_name > div:nth-child(2) span:nth-child(1) {
  color: #f00;
  font-weight: 600;
  padding: 0 10px;
  font-size: 1.5rem;
}
#status .list .item {
  display: flex;
  margin-bottom: 15px;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}
/* #status .list .item + .item {
  border-top: 1px solid #ccc;
} */
#status .list .item .date {
  width: 20%;
  display: flex;
  justify-content: space-between;
  margin-right: 10%;
}
#status .list .item .money {
  width: 30%;
}
#status .list .item .money > div {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
#status .list .item .money {
  width: 50%;
}
#status .list .item .item_status {
  width: 10%;
  margin-left: 10%;
}
#status .list .item .item_status .red {
  color: #f00;
}
#status .renewal {
  padding: 10px 16px;
}
#status .renewal .money {
  width: calc(90% + 54px);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: #f00;
}
#status .renewal .money span {
  padding: 10px 0;
  letter-spacing: 2px;
}
@media screen and (max-width: 767px) {
  #status .btn_box {
    margin: auto;
  }
  #status .btn_box.two {
    width: 100%;
    padding: 30px 0;
  }
  #status .content {
    padding: 20px 10px;
  }
  #status .content .message {
    padding: 0;
  }
  #status .content .list {
    padding: 0;
  }
  #status .content .update {
    padding: 0;
  }
  #status .update .file_item {
    height: 80px;
  }
  #status .update .file_item > span {
    padding: 8px 0;
  }
  #status .update .file_item .file_name > div:nth-child(2) span:nth-child(2) {
    display: none;
  }
  #status .list .item {
    flex-wrap: wrap;
  }
  #status .list .item .date {
    width: 100%;
    margin-right: 0;
    margin-bottom: 5px;
  }
  #status .list .item .money {
    width: 100%;
    margin-bottom: 5px;
  }
  #status .list .item .money > div {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
  }
  #status .list .item .money > div span:nth-child(1) {
    margin-right: 15px;
  }
  #status .list .item .money {
    width: 100%;
  }
  #status .list .item .item_status {
    width: 100%;
    margin-left: 0;
    text-align: right;
  }
  #status .renewal {
    padding: 10px 0;
  }
  #status .renewal .money {
    margin-bottom: 30px;
    width: 100%;
  }
}

.print_link {
  display: inline-block;
  cursor: pointer;
  padding: 5px 10px;
  background-color: #ee8b59;
  color: #fff;
  text-decoration: none;
  font-size: 15px;
  letter-spacing: 1px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/memberStatus.vue